import React from 'react'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiHeart, FiCpu } = FiIcons

const PsychologyAnalysis = ({ analysis, loading }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="bg-pink-100 p-2 rounded-lg">
          <SafeIcon icon={FiHeart} className="h-5 w-5 text-pink-600" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900">Psychology Analysis</h3>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-pink-600"></div>
          <span className="ml-2 text-gray-600">Analyzing psychology...</span>
        </div>
      ) : analysis ? (
        <div className="space-y-4">
          {analysis.summary && (
            <div className="bg-pink-50 border border-pink-200 rounded-lg p-4">
              <p className="text-pink-800 font-medium">Emotional Patterns</p>
              <p className="text-pink-700 mt-1">{analysis.summary}</p>
            </div>
          )}
          
          {analysis.insights && Array.isArray(analysis.insights) && (
            <div className="space-y-3">
              {analysis.insights.map((insight, index) => (
                <div key={index} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
                  <div className="bg-pink-100 p-1 rounded-full mt-1">
                    <SafeIcon icon={FiCpu} className="h-3 w-3 text-pink-600" />
                  </div>
                  <p className="text-gray-700 text-sm">{insight}</p>
                </div>
              ))}
            </div>
          )}

          {typeof analysis === 'string' && (
            <div className="prose prose-sm max-w-none text-gray-700">
              <p>{analysis}</p>
            </div>
          )}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <p>No psychology analysis available</p>
          <p className="text-sm mt-1">Add emotion data to your trades for better insights</p>
        </div>
      )}
    </div>
  )
}

export default PsychologyAnalysis